import { useCrud } from '@next-qr/lib-ui/hooks';
import type { CrudListOptions, CrudGetOptions } from '@next-qr/lib-ui/hooks/useCrud';
import { forwardApi } from './api';

export interface MailForward {
  id: number;
  source_email: string;
  destination_email: string;
}

const crud = useCrud<MailForward>(forwardApi);

export const useForwardList   = (options?: CrudListOptions) => crud.useList({ ...options, subscriptionFn: forwardApi.subscribe });
export const useForward       = (id: string | number, options?: CrudGetOptions) => crud.useGet(id, { ...options, subscriptionFn: forwardApi.subscribe });
export const useCreateForward = (options?: Parameters<typeof crud.useCreate>[0]) => crud.useCreate(options);
export const useUpdateForward = (options?: Parameters<typeof crud.useUpdate>[0]) => crud.useUpdate(options);
export const useRemoveForward = (options?: Parameters<typeof crud.useRemove>[0]) => crud.useRemove(options);
